<template>
    <div class="main">
        <c-panel title="AUDITORIA DE CONSULTAS" titleIcon="fas fa-user-secret">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Registro de quem consultou o quê, quando e de onde."
                description="Somente METADADOS: o conteúdo consultado nunca é gravado — o log registra a rota, a entidade e a contagem de registros retornados."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="De" class="u-mb-0">
                            <el-date-picker v-model="filtro.data_inicial" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width: 100%;" size="small"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Até" class="u-mb-0">
                            <el-date-picker v-model="filtro.data_final" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width: 100%;" size="small"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Usuário" class="u-mb-0">
                            <el-input v-model="filtro.nome" size="small" placeholder="Nome do usuário" @keyup.native.enter="carregar"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Perfil" class="u-mb-0">
                            <el-select v-model="filtro.user_tipo" clearable size="small" style="width: 100%;" @change="carregar">
                                <el-option v-for="(nome, tipo) in perfis" :key="tipo" :value="tipo" :label="nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Entidade" class="u-mb-0">
                            <el-input v-model="filtro.entidade" size="small" placeholder="aluno, turma..." @keyup.native.enter="carregar"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="3" class="u-text-right u-mt-25">
                        <el-button size="small" icon="el-icon-search" @click="carregar"></el-button>
                        <el-button class="u-ml-10" size="small" icon="el-icon-download" title="Exportar CSV" @click="exportar"></el-button>
                    </el-col>
                </el-row>
            </el-form>

            <!-- ==================== RESUMO ==================== -->
            <el-row v-if="resumo" :gutter="10" class="u-mb-20">
                <el-col :xs="12" :sm="6">
                    <div class="kpi"><span class="n">{{ resumo.total }}</span><span class="r">Consultas no período</span></div>
                </el-col>
                <el-col :xs="12" :sm="6">
                    <div class="kpi"><span class="n">{{ resumo.usuarios_distintos }}</span><span class="r">Usuários distintos</span></div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <div class="kpi kpi-lista">
                        <span class="r">Entidades mais consultadas</span>
                        <div>
                            <el-tag v-for="e in resumo.por_entidade.slice(0, 6)" :key="e.entidade" size="mini" class="u-mr-5">
                                {{ e.entidade || '—' }}: {{ e.total }}
                            </el-tag>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 160px;">Data/hora</th>
                            <th style="width: 200px;">Usuário</th>
                            <th>Rota</th>
                            <th style="width: 120px;">Entidade</th>
                            <th style="width: 80px;" class="u-text-center">ID</th>
                            <th style="width: 100px;" class="u-text-center">Registros</th>
                            <th style="width: 130px;">IP</th>
                            <th style="width: 90px;" class="u-text-center">Tempo</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="a in items" :key="a.id">
                            <td>{{ dataHora(a.created_at) }}</td>
                            <td>
                                {{ a.user_nome || '—' }}
                                <div><small class="u-text-muted">{{ perfis[a.user_tipo] || ('tipo ' + a.user_tipo) }}</small></div>
                            </td>
                            <td><small>{{ a.rota }}</small></td>
                            <td>{{ a.entidade || '—' }}</td>
                            <td class="u-text-center">{{ a.entidade_id || '—' }}</td>
                            <td class="u-text-center">{{ a.qtd_registros !== null ? a.qtd_registros : '—' }}</td>
                            <td>{{ a.ip || '—' }}</td>
                            <td class="u-text-center">{{ a.tempo_ms !== null ? a.tempo_ms + ' ms' : '—' }}</td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="8" class="u-text-center">Nenhuma consulta registrada para os filtros informados.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>

            <div v-if="paginacao.total > paginacao.per_page" class="u-text-center u-mt-15">
                <el-pagination background layout="prev, pager, next"
                    :current-page="paginacao.current_page" :page-size="paginacao.per_page"
                    :total="paginacao.total" @current-change="mudarPagina"></el-pagination>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO L — item 116: auditoria de consultas. */
export default {
    data: () => ({
        statusList: false, items: [], resumo: null,
        paginacao: { total: 0, per_page: 50, current_page: 1 },
        filtro: { data_inicial: '', data_final: '', nome: '', user_tipo: '', entidade: '' },
        perfis: {
            0: 'Secretário Escolar', 1: 'Diretor Escolar', 2: 'Professor', 3: 'Coordenador Pedagógico',
            4: 'NTI - PMVC', 5: 'NTI - SMED', 6: 'SMED - Legalização', 7: 'SMED - Pedagógico',
            8: 'SMED - RH', 9: 'SMED - Tabulação', 10: 'Consulta', 12: 'Vice-Diretor'
        }
    }),
    mounted () {
        const hoje = new Date().toISOString().substring(0, 10)
        this.filtro.data_final = hoje
        this.filtro.data_inicial = new Date(Date.now() - 29 * 86400000).toISOString().substring(0, 10)
        this.carregar()
    },
    methods: {
        carregar (pagina) {
            this.statusList = false
            const p = pagina || 1

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/consulta-auditoria/getAllPaginate?page=${p}`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    this.statusList = true
                    return
                }
                this.items = r.data.data || []
                this.paginacao = { total: r.data.total, per_page: r.data.per_page, current_page: r.data.current_page }
                this.statusList = true
            }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })

            this.carregarResumo()
        },
        carregarResumo () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/consulta-auditoria/resumo`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) return
                this.resumo = r.data
            }).catch(() => {})
        },
        mudarPagina (p) { this.carregar(p) },
        /**
         * A exportação devolve CSV cru (não JSON), então o download é montado a partir
         * do blob — o $axios comum devolveria texto e o navegador não baixaria nada.
         */
        exportar () {
            const cfg = JSON.parse(JSON.stringify(this.$store.getters.getHeaderAuth))
            cfg.responseType = 'blob'

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/consulta-auditoria/exportar`,
                this.filtro, cfg
            ).then(r => {
                const url = window.URL.createObjectURL(new Blob([r.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `auditoria-consultas-${this.filtro.data_final}.csv`)
                document.body.appendChild(link)
                link.click()
                link.remove()
            }).catch(e => this.$store.commit('throwException', e))
        },
        dataHora (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]} ${d.substring(11, 19)}`
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.kpi { border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px; text-align: center; margin-bottom: 8px; }
.kpi .n { display: block; font-size: 22px; font-weight: bold; }
.kpi .r { display: block; font-size: 11px; color: #606266; }
.kpi-lista { text-align: left; }
</style>
